module.exports = __webpack_public_path__ + "img/sunlong3.56ef4ef6.png";